import React, { Component, useEffect, useRef } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import './index.css';

import { useNavigate } from "react-router-dom";
import { errorCatch, LanguageContext, MetaContext, POST, QueryDetail, READWITH, TranslateContext, useAuth, UserConfigContext, UserContext } from 'fennec-ui';

// or 'antd/dist/antd.less'

import locale from 'antd/es/date-picker/locale/ru_RU';
import Icofont from 'react-icofont';

import GoCaptcha from 'go-captcha-react';

import {
  Form,
  Input,
  Select,
  Checkbox,
  Button,
  DatePicker,
  message,
  Typography
} from 'antd';
import InputPhone from "./input-phone";
import confirm from 'antd/lib/modal/confirm';
import FedHeader from '../FedHeader';
import { LangSwitchContext, TranslatesContext, useLayoutWidthContext } from '../../../components/Context';
import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { translate } from '../../../components/Tool';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import LangSwitch from '../../../components/LangSwitch';
import { useTranslation } from 'react-i18next';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
var _ = require('lodash');
dayjs.locale('ru');

const { Text, Link } = Typography;

const { Option } = Select;

function CaptchaInput({ auth, value, onChange, captchaRef }) {
  const [gocaptchaData, setGocaptchaData] = React.useState()

  // let captcha = undefined;
  // const captchaRef = useRef(null)
  // if (captchaRef?.current?.clear) {
  //   captchaRef.current.clear()
  // }
  // if (captchaRef?.current?.refresh) {
  //   captchaRef.current.refresh()
  // }

  const getGocaptcha = () => {
    auth.fetch('/api/gocaptcha').then(res => {
      if (res && res.data) {
        setGocaptchaData(res.data);
      }

      if (captchaRef?.current?.reset) {
        onChange(undefined)
        captchaRef.current.reset()
      }
    });
  }

  useEffect(() => {
    window.cr = captchaRef.current
  }, [captchaRef.current])

  React.useEffect(() => {
    getGocaptcha();
  }, [])

  return (<div className='go-captcha'>
    <div style={{
      display: (!value) ? "block" : "none"
    }}>
      <GoCaptcha.Slide
        config={{
          // width: 270,
          // height: 270,
          // thumbWidth: 50,
          // verticalPadding: 20,
          // horizontalPadding: 20,
          // showTheme: true,
          title: '',
          // iconSize: 20
        }}
        data={gocaptchaData || {}}
        events={{
          // move: (x, y) => console.log(`Перемещение элемента в точку (${x}, ${y})`),
          refresh: () => {
            getGocaptcha()
          },
          // close: () => console.log('Капча закрыта'),
          confirm: (point, reset) => {

            POST(auth, '/api/checkgocaptcha', { ...point, key: gocaptchaData?.key }, res => {
              if (res && res.data) {
                onChange(gocaptchaData?.key)
              } else {
                getGocaptcha()
              }
            })
          }
        }}
        ref={captchaRef}
      />
    </div>
  </div>)
}

function String({ value, onChange }) {
  return (
    <Input allowClear value={value} onChange={(v) => {
      let val = v.target.value
      if (val) {
        val = val.replace(/\s/g, '');
      }
      onChange(val)
    }
    } style={{ width: "100%" }} />
  )
}

function StringEe({ value, onChange }) {
  return (
    <Input allowClear value={value} onChange={(v) => {
      let val = v.target.value
      if (val) {
        val = val.replace(/Ё/g, 'E').replace(/ё/g, 'e');
      }
      onChange(val)
    }
    } style={{ width: "100%" }} />
  )
}

function Signup(props) {
  let navigate = useNavigate();
  const auth = useAuth();
  const dispatch = useDispatch();

  const { t } = useTranslation()

  const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
  const [translates, setTranslates] = useState();

  const [language, setLanguage] = useState({ lang: (auth.getCookie("lang") || "ru") })
  // const t = React.useMemo(() => _.bind(translate, {
  //   translate: translates,
  //   config: language
  // }), [translates, language]);
  // const t = useTranslateContext();

  const formRef = React.createRef();

  const [confirmDirty, setConfirmDirty] = React.useState(false)
  const [gender, setGender] = React.useState([])
  // const [recaptchaSite, setRecaptchaSite] = React.useState("")
  // const [gocaptchaData, setGocaptchaData] = React.useState()
  const [noCaptcha, setNoCaptcha] = React.useState(false)

  const captchaRef = useRef(null)

  // let captcha = undefined;
  // const domRef = useRef(null)
  // if (domRef?.clear) {
  //   domRef.clear()
  // }
  // if (domRef?.refresh) {
  //   domRef.refresh()
  // }

  // const getGocaptcha = (reset) => {
  //   auth.fetch('/api/gocaptcha').then(res => {
  //     if (res && res.data) {
  //       setGocaptchaData(res.data);
  //     }
  //     if (reset) {
  //       reset()
  //     }
  //   });
  // }

  useEffect(() => {
    READWITH(auth, 'Translate', [
      QueryDetail("model")
    ], ({ data }) => {
      if (data.length > 0) {
        let o = Object.fromEntries(data.map(i => {
          return [
            i.key,
            {
              ru: i.ru,
              en: i.en,
              es: i.es,
              tr: i.tr,
            },
          ]
        }));
        // dispatch(REDUX_Translate.actions.setObject(o));
        setTranslates(o)
      }
    }, errorCatch)
  }, [auth]);

  React.useEffect(() => {
    // auth.fetch('/api/recaptcha/site').then(res => {
    //   if (res && res.data) {
    //     setRecaptchaSite(res.data);
    //   }
    // });

    // getGocaptcha();

    auth.fetch('/api/query/gender?s-name=desc').then(res => {
      if (res && res.data) {
        setGender(res.data);
      }
    });

    auth.fetch('/api/getnocaptcha').then(res => {
      if (res && res.data) {
        setNoCaptcha(res.data);
      }
    });
  }, [])

  const handleSubmit = React.useCallback((values) => {
    confirm({
      title: <span><Icofont icon="exclamation-circle" style={{ color: "orange" }} /> Регистрация</span>,
      icon: undefined,
      content: <span style={{ fontSize: "13px" }}>ВНИМАНИЕ! Убедитесь что Вы указали правильный пол в форме регистрации,
        т.к. указанный Вами пол (<span style={{ fontWeight: "600" }}>{(values.genderID == "1") ? "Мужской" : "Женский"}</span>) влияет на дальнейшее участие в соревнованиях и не может быть изменен самостоятельно!</span>,
      okText: 'Все верно!',
      cancelText: 'Отмена',
      onOk() {
        auth.signup(values)
          .then(res => {
            if (!res.status) {
              if (captchaRef?.current?.refresh) {
                captchaRef.current.refresh();
              }

              //Валидация (подумать как сделать универсально)
              //Чистим ошибки предыдущей валидации
              formRef.current.setFieldsValue(formRef.current.getFieldsValue());
              //Показываем новые ошибки
              if (res.invalid && res.invalid.errors) {
                var object = res.invalid.errors
                for (const key in object) {
                  if (object.hasOwnProperty(key)) {
                    const element = object[key];
                    if (element && element.length) {
                      var valData = [];
                      valData.push({
                        name: key,
                        errors: [element[0].message],
                        value: (element[0].value) ? element[0].value : ""
                      })
                      formRef.current.setFields(valData);
                    }
                  }
                }
              }
              message.error(res.message);
            } else {
              auth.redirect(res);
            }
          })
          .catch(err => {
            if (captchaRef?.current?.refresh) {
              captchaRef.current.refresh();
            }
            console.log(err)
          })
      },
      onCancel() {
      },
    })
  }, [captchaRef, formRef])

  const handleConfirmBlur = (e) => {
    const { value } = e.target;
    setConfirmDirty(confirmDirty || !!value);
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
    },
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };

  const genderOption = gender.map((d) => <Option key={d.ID}>{d.name}</Option>);
  return (
    <TranslatesContext.Provider value={translates}>
      <TranslateContext.Provider value={t}>
        <LanguageContext.Provider value={[language, setLanguage]}>
          <LangSwitchContext.Provider value={<LangSwitch />}>
            <Layout>
              <FedHeader layout={"web"} hideLogo={true}>
                {/* <MenuOne menu={menu(status, notify)} /> */}
              </FedHeader>
              <Content style={{ padding: '6px', backgroundColor: "white" }}>
                <div style={{
                  height: "calc(100vh - 12px)",
                  backgroundColor: "white",
                  margin: "5px",
                  borderRadius: "5px"
                }}>

                  {/* <GoCaptcha.Slide
        config={{
          // width: 200,
          // height: 200,
          // thumbWidth: 50,
          // verticalPadding: 20,
          // horizontalPadding: 20,
          // showTheme: true,
          title: 'Slide CAPTCHA',
          // iconSize: 20
        }}
        data={gocaptchaData || {}}
        events={{
          move: (x, y) => console.log(`Перемещение элемента в точку (${x}, ${y})`),
          refresh: () => {
            getGocaptcha()
          },
          close: () => console.log('Капча закрыта'),
          confirm: (point, reset) => {
            console.log(point)

            POST(auth, '/api/checkgocaptcha', point, res => {
              if (res && res.data) {
                console.log(res.data)
                // setGocaptchaData(res.data);
              }
            })

            // reset()
            // getGocaptcha(reset)
            // return reset() || confirm(point, reset) 
          } // Подтверждение решения
        }}
        ref={domRef}
      /> */}

                  <div className="register-form" style={{ paddingBottom: "0px", textAlign: "center", maxWidth: (props.mobile) ? "300px" : "600px" }}>
                    <a href={auth.schemhttp + "://" + auth.getDomainWithoutSubdomain(window.location.href)}>
                      <img style={{ height: "70px" }} src="/resources/logo-blue.svg" alt="Logo" />
                    </a>
                  </div>

                  <Form ref={formRef} name="register" {...formItemLayout}
                    onFinish={handleSubmit}
                    onFinishFailed={({ errorFields }) => {
                      formRef.current.scrollToField(errorFields[0].name);
                    }}
                    className="register-form"
                    style={{ maxWidth: (props.mobile) ? "300px" : "600px", paddingTop: "5px" }}

                    initialValues={{
                      // genderID: '1',
                      tipTelefonaID: '1',
                    }}
                  >
                    <div style={{
                      backgroundColor: "white",
                      padding: (props.mobile) ? "0px" : "25px",
                      boxShadow: "1px 1px 8px 0px rgba(34, 60, 80, 0.2)",
                      borderRadius: "5px"
                    }}>
                      <Form.Item label={t("signup.Адрес электронной почты")}
                        name="email"
                        rules={[
                          {
                            type: 'email',
                            message: t('signup.Введен неверный адрес электронной почты!'),
                          },
                          {
                            required: true,
                            message: t('signup.Пожалуйста, введите свой адрес электронной почты!'),
                          },
                        ]}
                      >
                        <String />
                      </Form.Item>
                      <Form.Item label={t("signup.Пароль")} hasFeedback
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: t('signup.Пожалуйста, введите пароль не меньше 8 символов!'),
                          },
                          {
                            min: 8,
                            message: t('signup.Пожалуйста, введите пароль не меньше 8 символов!'),
                          },
                        ]}
                      >
                        <Input.Password />
                      </Form.Item>
                      <Form.Item label={t("signup.Повторите пароль")} hasFeedback
                        name="confirm"
                        dependencies={['password']}
                        rules={[
                          {
                            required: true,
                            message: t('signup.Пожалуйста, повторите ваш пароль!'),
                          },
                          {
                            min: 8,
                            message: t('signup.Пожалуйста, повторите ваш пароль!'),
                          },
                          ({ getFieldValue }) => ({
                            validator(rule, value) {
                              if (!value || getFieldValue('password') === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(t('signup.Пароли не совпадают!'));
                            },
                          }),
                        ]}
                      >
                        <Input.Password onBlur={handleConfirmBlur} />
                      </Form.Item>

                      <Form.Item label={t("signup.Фамилия")}
                        name="lastname"
                        rules={[{ required: true, message: t('signup.Пожалуйста, введите фамилию!') }]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item label={t("signup.Имя")}
                        name="firstname"
                        rules={[{ required: true, message: t('signup.Пожалуйста, введите имя!') }]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item label={t("signup.Отчество")}
                        name="patronymic"
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item label={t("signup.Дата рождения")}
                        name="birthday"
                        rules={[{ required: true, message: t('signup.Пожалуйста, введите дату рождения!') }]}
                      >
                        <DatePicker format="DD.MM.YYYY" locale={locale} />
                      </Form.Item>

                      <Form.Item label={t("signup.Пол")}
                        name="genderID"
                        rules={[{ required: true, message: t('signup.Пожалуйста, укажите пол!') }]}
                      >
                        <Select defaultActiveFirstOption={false}>
                          {genderOption}
                        </Select>
                      </Form.Item>

                      <Form.Item label={t("signup.Телефон")}
                        name="phone"
                        rules={[
                          { required: true, message: t('signup.Пожалуйста, введите телефон!') },
                          { pattern: /\d{8,}/g, message: t('signup.Пожалуйста, введите телефон!') }
                        ]}
                      >
                        <InputPhone />
                      </Form.Item>

                      {(!noCaptcha) && <Form.Item label={""}
                        style={{ display: "flex", justifyContent: "center" }}
                        name="captcha"
                        rules={[{ required: true, message: t('signup.Мы должны убедиться, что вы человек!') }]}
                      >
                        {/* <ReCAPTCHA
              ref={e => (captcha = e)}
              sitekey={recaptchaSite}
            /> */}
                        <CaptchaInput auth={auth} captchaRef={captchaRef} />
                      </Form.Item>}

                      <Form.Item {...tailFormItemLayout}
                        name="agreement"
                        valuePropName="checked"
                        rules={[{
                          validator: (_, value) => value ? Promise.resolve() : Promise.reject(t('signup.Вы должны согласиться с условиями!'))
                        }]}
                      >
                        <Checkbox>
                          {t("signup.Вам необходимо поставить «галочку», подтвердив тем самым, что Вы")}
                          {t("signup.принимаете условия")} <a target="_blank" rel="noopener noreferrer" href="https://social-dance.club/fed/about/user-agreement">{t("signup.Пользовательского соглашения")}</a>,
                          {t("signup.ознакомлены и согласны с")} <a target="_blank" rel="noopener noreferrer" href="https://social-dance.club/fed/about/privacy-policy"> {t("signup.Политикой конфиденциальности")}</a>.
                        </Checkbox>

                      </Form.Item>
                      <Form.Item {...tailFormItemLayout}>
                        <Button type="primary" htmlType="submit">
                          {t("signup.Регистрация")}
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>
                </div>
              </Content>
              {/* <Footer style={{ textAlign: 'center', fontSize: "12px" }}>
                                        Общероссийская физкультурно-спортивная общественная организация "Всероссийская федерация социальных танцев"
                                    </Footer> */}
            </Layout>
          </LangSwitchContext.Provider>
        </LanguageContext.Provider>
      </TranslateContext.Provider>
    </TranslatesContext.Provider>
  );
}

// const Signup = Form.create({ name: 'register' })(RegistrationForm);
export default Signup;